import React from 'react'

import { CardContainer } from '../ui/components'
import { getUser } from '../../utils'

import { HomeBannerSvg } from '../../assets/icons/svgComponents'

import * as S from './styles'

const Banner = () => {
  const me = getUser()

  return (
    <S.Wrapper>
      <CardContainer style="home-banner" backgroundColor="#017849">
        <HomeBannerSvg className="home-banner-svg" />
        <div className="right-content">
          <h2>
            Olá, {me?.usuario.nome.split(' ')[0]}{' '}
            {me?.usuario.nome.split(' ')[1]}!
          </h2>
          <h3>Para iniciar o atendimento, selecione ou cadastre um paciente</h3>
        </div>
      </CardContainer>
    </S.Wrapper>
  )
}

export default Banner
